import UserStore from "../../stores/UserStore";
import { BrowserRouter as Redirect, Route, withRouter } from "react-router-dom";
import Can from "../authentication/Can";
import { observer } from "mobx-react";

import React, { Component } from "react";

class ProtectedRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }
  async componentDidMount() {
    this.setState({ loading: true });
    try {
      let res = await fetch("/isLoggedIn", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      let result = await res.json();

      if (result && result.success) {
        UserStore.loading = false;
        UserStore.isLoggedIn = true;
        UserStore.username = result.username;
        UserStore.permissions = result.permissions;
      } else {
        UserStore.loading = false;
        UserStore.isLoggedIn = false;
        UserStore.permissions = [{ name: "visitor" }];
      }
    } catch (e) {
      UserStore.loading = false;
      UserStore.isLoggedIn = false;
      UserStore.permissions = [{ name: "visitor" }];
      console.log(e);
    }
    this.setState({ loading: false });
  }
  render() {
    if (this.state.loading) {
      return <div>Loading...</div>;
    }
    const { component: Component, ...props } = this.props;
    return (
      <Route
        {...props}
        render={(props) => (
          <Can
            role={UserStore.permissions}
            perform={this.props.pageName.concat(":visit")}
            yes={() => <Component {...props} />}
            no={() => {
              if (UserStore.isLoggedIn) {
                this.props.history.push("/");
                return <Redirect to="/" />;
              } else {
                this.props.history.push("/login");
                return (
                  <Redirect
                    to={{
                      pathname: "/login",
                      state: { from: this.props.path },
                    }}
                  />
                );
              }
            }}
          />
        )}
      />
    );
  }
}

export default withRouter(observer(ProtectedRoute));
